import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20toned%20abstract%20artistic%20illustration%20with%20flowing%20curves%20and%20soft%20gradients%20in%20warm%20orange%20and%20cream%20tones%2C%20subtle%20graphic%20novel%20aesthetic%2C%20clean%20minimal%20composition%2C%20elegant%20modern%20design%2C%20no%20text%2C%20simple%20abstract%20shapes%2C%20wide%20landscape%20format&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="虚空韩漫网背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/50 via-foreground-900/30 to-foreground-900/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1200px] mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/20 backdrop-blur-sm rounded-full text-background-50 text-xs font-medium mb-6">
          <i className="ri-sparkling-line"></i>
          全新升级 · 更流畅的阅读体验
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 font-heading mb-4 leading-tight">
          虚空韩漫网
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-[600px] mx-auto mb-8 leading-relaxed">
          高清下拉式韩漫全集免费阅读平台。收录海量正版韩国漫画，
          <br className="hidden sm:block" />
          每日更新，随开随看，畅享极致阅读体验。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
          >
            <i className="ri-play-circle-line text-lg"></i>
            立即开始阅读
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 backdrop-blur-sm text-background-50 rounded-full text-base font-medium hover:bg-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer border border-background-50/20"
          >
            <i className="ri-information-line"></i>
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">200+</p>
            <p className="text-xs text-background-50/60 mt-1">正版韩漫</p>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">50万+</p>
            <p className="text-xs text-background-50/60 mt-1">活跃读者</p>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">99.7%</p>
            <p className="text-xs text-background-50/60 mt-1">好评率</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent z-10"></div>
    </section>
  );
}